import { Application } from '@hotwired/stimulus';
import AddressForm from './section-p/address-form';
import { SimpleLoginController } from './login/simple-login.stimulus';
import { shouldLoad as shouldSiteHeaderAltLoad } from './site-headers/site-header-alt-loader';
import { shouldLoad as shouldMyContentItemGroupsLoad } from './section-m/my-content-item-groups-loader';

// v2
import { shouldLoad as shouldContactSectionLoad } from "./v2/section/contact-section/contact-section--loader";
import { shouldLoad as shouldVideoSectionLoad } from "./v2/section/video-section/video-section--loader";
import { shouldLoad as shouldFieldLoad } from "./v2/fields/field--loader";
import { shouldLoad as shouldFieldsSelectFieldLoad } from "./v2/fields/fields-select-field/fields-select-field-loader";
import { shouldLoad as shouldModalLoad } from "./v2/modal/modal--loader";
import { shouldLoad as shouldOrderOverviewLoad } from "./v2/settings-block/settings-block--order-overview/settings-block--order-overview-loader";
import { shouldLoad as shouldPasswordFieldLoad } from "./v2/fields/password-field/password-field-loader";
import { shouldLoad as shouldTabsLoad } from "./v2/tabs/tabs-loader";
import { shouldLoad as shouldTextareaFieldLoad } from "./v2/fields/textarea-field/textarea-field-loader";
import { shouldLoad as shouldFieldCounterLoad } from "./v2/fields/field-counter--loader";
import { shouldLoad as shouldCardGalleryLoad } from "./v2/card-gallery/card-gallery-loader";

export default async function init(application: Application) {
    AddressForm();

    SimpleLoginController.register(application);

    if (shouldSiteHeaderAltLoad()) {
        const { SiteHeaderAltController } = await import('./site-headers/site-header-alt.stimulus');
        SiteHeaderAltController.register(application);
    }

    if (shouldMyContentItemGroupsLoad()) {
        const { MyContentItemGroupsController } = await import('./section-m/my-content-item-groups.stimulus');
        MyContentItemGroupsController.register(application);
    }

    // v2
    if (shouldContactSectionLoad()) {
        const { ContactSectionController } = await import('./v2/section/contact-section/contact-section.stimulus');
        ContactSectionController.register(application);
    }

    if (shouldVideoSectionLoad()) {
        const { VideoSectionController } = await import('./v2/section/video-section/video-section.stimulus');
        VideoSectionController.register(application);
    }

    if (shouldFieldLoad()) {
        const { FieldController } = await import('./v2/fields/field.stimulus');
        FieldController.register(application);
    }

    if (shouldFieldsSelectFieldLoad()) {
        const { FieldsSelectFieldController } = await import('./v2/fields/fields-select-field/fields-select-field.stimulus');
        FieldsSelectFieldController.register(application);
    }

    if (shouldModalLoad()) {
        const { ModalController } = await import('./v2/modal/modal.stimulus');
        ModalController.register(application);
    }

    if (shouldOrderOverviewLoad()) {
        const { OrderOverviewController } = await import('./v2/settings-block/settings-block--order-overview/settings-block--order-overview.stimulus');
        OrderOverviewController.register(application);
    }

    if (shouldPasswordFieldLoad()) {
        const { PasswordFieldController } = await import('./v2/fields/password-field/password-field.stimulus');
        PasswordFieldController.register(application);
    }

    if (shouldTabsLoad()) {
        const { TabsController } = await import('./v2/tabs/tabs.stimulus');
        TabsController.register(application);
    }

    if (shouldTextareaFieldLoad()) {
        const { TextareaFieldController } = await import('./v2/fields/textarea-field/textarea-field.stimulus');
        TextareaFieldController.register(application);
    }

    if (shouldFieldCounterLoad()) {
        const { FieldCounterController } = await import('./v2/fields/field-counter.stimulus');
        FieldCounterController.register(application);
    }

    if (shouldCardGalleryLoad()) {
        const { CardGalleryController } = await import('./v2/card-gallery/card-gallery.stimulus');
        CardGalleryController.register(application);
    }
}
